module.exports = __webpack_public_path__ + "media/src/images/icons/pen-e6ce45df61ca71c838aad6284b2378df.svg";